import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IProductOffering } from "../types/products";

const API = process.env.REACT_APP_API;

interface CreateProductOfferingData {
  product: number;
  fair: number;
  price: string;
  cost: string;
  stock: number;
  unlimited_stock: boolean;
  available: boolean;
}

const useCreateProductOffering = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: ({
      fairId,
      offering,
    }: {
      fairId: number;
      offering: CreateProductOfferingData;
    }) => {
      // O fair já está no offering, mas o endpoint espera fairId na URL
      return fetch(`${API}/api/semeadora/fairs/${fairId}/offerings/`, {
        method: "POST",
        body: offering,
      }) as Promise<IProductOffering>;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["product-offerings", variables.fairId],
      });
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useCreateProductOffering;
